module.exports = __webpack_public_path__ + "static/4.2_1086x850_Mobile_gradient_2X--b5e22207b3b15364f6cd1f3750616b5d.png";